import { Network, WALLETS_WHITELIST_STATUS, WALLETS_WHITELIST_STATUS_BUTTON_TEXT } from "interfaces";
import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";

import { useStores } from "stores";
import { ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { requestWithNotify } from "utils";
import { useNotificationContext } from "providers";
import { allowWalletWhitelist, forbidWalletWhitelist } from "services";
import { useState } from "react";

export const WalletAddressActionBtn = observer(
  ({
    status,
    walletAddress,
    network,
    walletId,
  }: {
    status: keyof typeof WALLETS_WHITELIST_STATUS;
    walletAddress: string;
    network: Network;
    walletId: string;
  }) => {
    const { actionModals, user, walletsWhitelist } = useStores();
    const { openNotification } = useNotificationContext();
    const companyId = user.userInfo?.company_id || "";
    const [loading, setLoading] = useState(false);

    async function handelAllowWallet() {
      try {
        setLoading(true);
        const res = await requestWithNotify({
          fetchFn: () => allowWalletWhitelist({ companyId, walletId }),
          openNotification,
          successMsg: ` Адрес ${walletAddress} разрешен`,
          errorMsg: "Ошибка при разрешении адреса",
        });

        if (res.result) {
          await requestWithNotify({
            fetchFn: () => walletsWhitelist.fetch(),
            openNotification,
          });
        }
      } finally {
        setLoading(false);
      }
    }

    const CONFIG_BTN: Record<WALLETS_WHITELIST_STATUS, () => void> = {
      ALLOWED: () =>
        actionModals.open(
          () => (
            <ConfirmationModal
              calledQuery={async () => await forbidWalletWhitelist({ companyId, walletId })}
              text={`Вы уверены, что хотите запретить использование адреса ${walletAddress} (${network})?`}
              successText={`Адрес ${walletAddress} запрещен`}
              buttonText="Запретить"
              cancelButtonText="Отмена"
              fullWidth={true}
              onSuccess={async () => {
                setLoading(true);
                try {
                  await requestWithNotify({
                    fetchFn: () => walletsWhitelist.fetch(),
                    openNotification,
                  });
                } finally {
                  setLoading(false);
                }
              }}
            />
          ),
          { title: "Запрет адреса", width: "550px" }
        ),

      FORBIDDEN: () => handelAllowWallet(),
    };

    return (
      <CustomButton size="small" variant="outlined" onClick={CONFIG_BTN[status]} loading={loading} disabled={loading}>
        {WALLETS_WHITELIST_STATUS_BUTTON_TEXT[status]}
      </CustomButton>
    );
  }
);
